import {
  ADD_POINT_SYSTEM_ERROR,
  ADD_POINT_SYSTEM_LOADING,
  ADD_POINT_SYSTEM_SUCCESS,
} from "../../../constant/actionTypes";

const createPointSystemReducer = (state = {}, action) => {
  switch (action.type) {
    case ADD_POINT_SYSTEM_LOADING: {
      let obj = {
        loading: true,
      };
      return obj;
    }
    case ADD_POINT_SYSTEM_SUCCESS: {
      let obj = {
        loading: false,
        data: action.response,
      };
      return obj;
    }
    case ADD_POINT_SYSTEM_ERROR: {
      let obj = {
        loading: false,
        status: action.response,
      };
      return obj;
    }
    default:
      return state;
  }
};

export default createPointSystemReducer;
